<ap-dropdown
  #dropdown
  [title]="filterColumn().label"
  [list]="options()"
  [selectType]="optionsType"
  [disabled]="isDisabled()"
  class="w-100"
  [(ngModel)]="value"
  (onSelect)="updateModelHandler()"
  (onClose)="closeHandler()">
  @for (item of options(); track $index) {
    <ap-dropdown-list-item [item]="item" optionName="key" optionValue="value" />
  }
</ap-dropdown>
